<template>
  <div class="account-box">
    <VueSlickCarousel
          v-bind="settings"
          v-if="accountlist && accountlist.length > 0"
        >
          <div
            class="swiper-slide flex-box-x"
            v-for="(item, index) in accountlist"
            :key="index"
          >
          <div class="account-box-item">
          <div class="account-box-item-icon">
            <img
              src="../../../assets/imgs/homeleft.png"
            />
          </div>
          <div class="account-box-item-desc">
            <span class="account-color">{{ $t("home.Congratulations") }}</span> {{ item.id }}
            <span class="account-color">{{ $t("home.withdrawn") }}</span> {{ item.nums }}
            {{ $t("common.unit") }}
          </div>
          <div style="clear: both;" />
        </div>
          </div>
        </VueSlickCarousel>
  </div>
</template>

<script>
import { Toast } from "vant";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { formatNumberWithCommas } from "../../../utils/validate";
export default {
  name: "TmpAccount",
  components: { VueSlickCarousel },
  data() {
    return {
      accountlist: [],
      min:0,
      max:0,
      settings: {
        centerMode: true,
        centerPadding: "0px",
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        swipeToSlide: true,
        autoplay: true,
        arrows:false
      },
    };
  },
  mounted() {
    this.getSetting()
  },
  methods: {
    getSetting() {
      this.$http({
        method: "get",
        url: "getloansetting",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.min = parseInt(res.data.minimum);
            this.max = parseInt(res.data.highest);
            this.showdata();
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    formatNumberWithCommas(val) {
      return formatNumberWithCommas(val);
    },
    randomRange(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    showdata() {
      this.accountlist = [];
      const len = 100;
      const m = new Date().getMonth() + 1;
      const d = new Date().getDate();
      const md = (m > 9 ? m : "0" + m) + " - " + (d > 9 ? d : "0" + d);
      for (var index = 0; index < len; index++) {
        let id = this.randomRange(100000, 999999).toString();

        const money = this.randomRange(this.min, this.max);
        this.accountlist.push({
          md: md,
          id: id.substring(0, 2) + "****" + id.substring(2),
          nums: formatNumberWithCommas(money),
        });
      }
    },
  },
};
</script>
<style scoped>
.account-box {
  background-color: rgb(210 244 255 / 1);
  padding: 10px;
}
.account-box-item {
    line-height: 24px;
    font-size: 12px;
}
.account-box-item-icon{
    height: 24px;width: 16px;float: left;
}
.account-box-item-icon img {
    width: 16px;
    height: 16px;
    margin-top: 6px;
}
.account-box-item-desc{
    height: 24px;float: left;width: calc(100% - 30px);
    line-height: 2.6;
    font-size: 11px;
}
.account-color {
    color: rgb(4 109 181/1);
}
</style>
